import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  IGetSiteQueryParams,
  IListaPaginada,
  ISite
} from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  private readonly baseURL = '/Site';
  constructor(private httpClient: HttpClient) {}

  getSite(body: IGetSiteQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<ISite>>>(
      this.baseURL,
      body
    );
  }
}
